module.exports = {"version":"0.16.0"}


//////////////////
// WEBPACK FOOTER
// ./~/ethpm-registry/~/truffle-contract/~/web3/lib/version.json
// module id = 480
// module chunks = 0